import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Callout } from '@fluid/callouts';
import { Heading } from '@fluid/typography-ui';
import SpinningArcs from './SpinningArcs';

// Styles
import './styles/loading-state.scss';

class LoadingState extends PureComponent {
    static defaultProps = {};

    static propTypes = {
        contextCls: PropTypes.string,
        title: PropTypes.string,
        msg: PropTypes.string,
    };

    render() {
        const { contextCls, title, msg } = this.props;

        return (
            <Callout contextCls={cx(this.baseCls, contextCls)}>
                {this.renderSpinner()}
                {(title || msg) && this.renderMessaging()}
            </Callout>
        );
    }

    renderSpinner = () => {
        return (
            <div className={`${this.baseCls}__spinner-container`}>
                <SpinningArcs baseDimension={75} />
            </div>
        );
    };

    renderMessaging = () => {
        const { title, msg } = this.props;

        return (
            <div
                className={cx(
                    'fluid-callout__text-container',
                    `${this.baseCls}__text-container`,
                )}
            >
                {title && (
                    <div
                        className={cx(
                            'fluid-callout__title-container',
                            `${this.baseCls}__title-container`,
                        )}
                    >
                        <Heading
                            contextCls={cx(
                                'fluid-callout__title',
                                `${this.baseCls}__title`,
                            )}
                        >
                            {title}
                        </Heading>
                    </div>
                )}
                {msg && (
                    <div
                        className={cx(
                            'fluid-callout__msg-container',
                            `${this.baseCls}__msg-container`,
                        )}
                    >
                        <p
                            className={cx(
                                'fluid-callout__msg',
                                `${this.baseCls}__msg`,
                            )}
                        >
                            {msg}
                        </p>
                    </div>
                )}
            </div>
        );
    };

    baseCls = 'fluid-loading-state';
}

export default LoadingState;
